// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { CaseAssetOut } from './caseAssetOut.zod.ts';
import { MetricOut } from './metricOut.zod.ts';
import { Tag } from './tag.zod.ts';

export const CaseOut = zod.object({
  "achievements": zod.string(),
  "aliases": zod.array(zod.string()),
  "anonymization_confirmed_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "anonymized_label": zod.string(),
  "approach": zod.string(),
  "assets": zod.array(CaseAssetOut),
  "client_name": zod.union([zod.string(),zod.null()]),
  "country": zod.union([zod.string(),zod.null()]),
  "id": zod.uuid(),
  "industry": zod.union([Tag,zod.null()]),
  "label": zod.string(),
  "metrics": zod.array(MetricOut),
  "objective": zod.string(),
  "shareable": zod.boolean(),
  "situation": zod.string(),
  "status": zod.string(),
  "type": zod.string(),
  "updated_at": zod.iso.datetime({"offset":true}),
  "view": zod.enum(['named', 'anonymized'])
});

export type CaseOut = zod.input<typeof CaseOut>;
export type CaseOutOutput = zod.output<typeof CaseOut>;
